exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".delivery-table[data-v-2285002a]{width:100%;border-collapse:collapse;margin:8px 0;font-size:.9em}.delivery-table>tbody>tr>td>span[data-v-2285002a]{font-size:1.2rem}.text-uppercase[data-v-2285002a]{text-transform:uppercase!important}", ""]);

// exports
